// Normalizes the "service" invoice type shared by ARSL/ATL/AE/ES, built by
// buildService() in functions/builders/helpers.js:22 — headCount x 350,
// plus 16% GST. This is the only one of the two invoices these clients
// generate per segment that carries any service charge / GST / WHT at all.
import { LINE_CATEGORIES, makeLine } from "../lineCategories";

export function normalizeHeadcountServiceInvoice(invoice) {
  const serviceAmount = Number(invoice.serviceAmount || 0);
  const gstAmount = Number(invoice.gst || 0);
  const grossAmount = Number(invoice.grandTotal || (serviceAmount + gstAmount));

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: `Service charges (${invoice.headCount || 0} head)`, amount: serviceAmount, sourceField: "serviceAmount" }),
    makeLine({ category: LINE_CATEGORIES.GST, description: "GST on service charges", amount: gstAmount, sourceField: "gst" })
  ];

  return {
    lines,
    serviceChargeSubtotal: serviceAmount,
    invoiceAmount: serviceAmount,
    gstAmount,
    grossAmount,
    recoveryBase: null,
    recoveryAddBack: null
  };
}
